import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaStar } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import client4 from "../assets/client4.png";
import client3 from "../assets/client3.png";
import client5 from "../assets/client5.png";
import client7 from "../assets/client7.png";

const TESTIMONIALS = [
  {
    logo: client4,
    name: "Team Green Valley",
    quote: "Working with the team has been a great experience. Their SEO strategy helped us improve our search visibility and attract the right audience consistently.",
  },
  {
    logo: client3,
    name: "Team DPal Growth",
    quote: "Our PPC campaigns started delivering quality leads within a short time. The team managed everything efficiently and helped improve our overall ROI.",
  },
  {
    logo: client5,
    name: "Team Harmony",
    quote: "We've seen a noticeable improvement in our digital presence. The team's approach is professional, structured, and focused on delivering real results.",
  },
  {
    logo: client7,
    name: "Team Q Global",
    quote: "Their SEO and marketing strategies helped us build a stronger online presence. The results have been consistent and aligned with our business goals.",
  },
  {
    logo: client4,
    name: "Team Green Valley",
    quote: "The team understands our business needs well and provided strategies that actually worked. We've seen steady growth in traffic and engagement.",
  },
  {
    logo: client3,
    name: "Team DPal",
    quote: "From campaign setup to optimization, everything was handled smoothly. We experienced better performance and more targeted leads from our ads.",
  },
];

function Testimonials() {
  return (
    <section className="testimonial">
      <div className="testimonial-header">
        <p>— Testimonials —</p>
        <h2>What Our Clients Say</h2>
        <span>Real feedback from businesses we've worked with and helped grow online.</span>
      </div>
      <div className="testimonial-slider">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={2}
          loop={true}
          speed={900}
          autoplay={{ delay: 2800, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={{ clickable: true }}
          breakpoints={{ 0: { slidesPerView: 1 }, 768: { slidesPerView: 2 } }}
        >
          {TESTIMONIALS.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="testi-card">
                <div className="testi-logo-img">
                  <img src={item.logo} alt={item.name} />
                </div>
                <div className="testi-stars">
                  {[...Array(5)].map((_, s) => <FaStar key={s} />)}
                </div>
                <p className="testi-quote">"{item.quote}"</p>
                <div className="testi-name">
                  <strong>{item.name}</strong>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;
